import Tag from "../atoms/Tag";
import ImageWrapper from "../atoms/ImageWrapper";
import { Link, useLocation } from "react-router-dom";

export type NewsItem = {
  id: number;
  title: string;
  date: string;
  category: string;
  image: string;
  slug: string;
  contentHtml: string;
  tags: string[];
};

type Props = {
  item: NewsItem;
};

const NewsCard = ({ item }: Props) => {
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  return (
    <Link to={`/${lang}/blog/news/${item.slug}`}>
      <div className="relative w-full rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer aspect-[5/3]">
        
        {/* IMAGE */}
        <ImageWrapper
          src={item.image}
          alt={item.title}
          className="w-full h-auto object-cover aspect-[5/3]"
        />

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/20"></div>

        {/* CATEGORY TAG – kanan atas */}
        <div className="absolute top-3 right-3">
          <Tag label={item.category} />
        </div>

        {/* CONTENT */}
        <div className="absolute inset-0 p-4 flex flex-col justify-end text-white">
          <h3 className="mt-2 font-semibold text-lg line-clamp-2">
            {item.title}
          </h3>

          {item.tags?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1">
              {item.tags.map((tag, index) => (
                <span
                  key={index}
                  className="text-xs bg-white/30 px-2 py-0.5 rounded-full"
                >
                  #{tag}
                </span>
              ))}
            </div>
          )}

          <p className="text-xs mt-1 text-gray-200">{item.date}</p>
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;
